import React from "react";
import {
  SafeAreaView,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
  View,
} from "react-native";

import Icons from "../../common/icons/index";
import AppTheme from "../../AppTheme";

export default function CarouselProgressBar({
  currentScreenIndex,
  numberOfScreens,
  hideNext = false,
  changeScreen = () => {},
}) {
  const isFirstScreen = currentScreenIndex == 0 && !hideNext;
  const width = Math.max(
    0,
    Math.round((currentScreenIndex * 100) / numberOfScreens),
  );

  return (
    <SafeAreaView style={styles.pager}>
      {isFirstScreen ? (
        <TouchableOpacity
          onPress={() => changeScreen(-1)}
          style={styles.button}
        >
          <Text style={styles.buttonText}>Exit</Text>
        </TouchableOpacity>
      ) : (
        <Icons.Back
          color={AppTheme.almostBlack}
          style={styles.backIcon}
          onPress={() => changeScreen(-1)}
        />
      )}

      <View style={styles.progressContainer}>
        <View style={styles.progress}>
          <View style={[styles.complete, { width: `${width}%` }]} />
        </View>
      </View>

      {hideNext ? (
        <View style={{ width: 44 }} />
      ) : (
        <TouchableOpacity
          onPress={() => changeScreen(1)}
          style={[styles.button]}
        >
          <Text style={styles.buttonText}>Next</Text>
        </TouchableOpacity>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  pager: {
    width: "96%",
    marginHorizontal: "3%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    zIndex: 2,
    minHeight: 70,
  },
  backIcon: {
    minWidth: 44,
    height: 20,
    zIndex: 10,
  },
  button: {
    backgroundColor: "#F3F2F1",
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
    marginHorizontal: 5,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  progressContainer: {
    flex: 1,
  },
  progress: {
    position: "relative",
    height: 4,
    width: "100%",
    backgroundColor: "#DADADA",
    borderRadius: 3,
  },
  complete: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 4,
    width: "100%",
    borderRadius: 3,
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
});
